module.exports = __webpack_public_path__ + "media/brand/brushStrokes-5c35e7cd.svg";